import { render } from "./MyButton.vue?vue&type=template&id=f07dc8d4&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=f07dc8d4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/nush-bookings/nush-bookings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f07dc8d4"]])

export default __exports__